document.addEventListener("DOMContentLoaded", function () {
  const paragraphs = document.querySelectorAll(".text .richtext-output p");
  paragraphs.forEach((pTag) => {
    const nextSibling = pTag.nextElementSibling;
    if (nextSibling && nextSibling.tagName === "P") {
      pTag.classList.add("less-margin");
    }
  });
});
